var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-alert",
    { staticClass: "section-error", attrs: { variant: "warning", show: "" } },
    [
      _c(
        "div",
        { staticClass: "section-error__row" },
        [
          _c(
            "span",
            [
              _c("feather-icon", {
                staticClass: "mr-50",
                attrs: { icon: "AlertTriangleIcon", size: "15" },
              }),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.message || _vm.$t("influencer_panel.section_error")
                  ) +
                  " "
              ),
            ],
            1
          ),
          _c(
            "b-button",
            {
              attrs: { variant: "flat-warning", size: "sm" },
              on: {
                click: function ($event) {
                  return _vm.$emit("retry")
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("influencer_panel.retry")) + " ")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }